// @ts-nocheck
/** Modified version of Backbone.Obscura
 *  including (performance-)patches from
 *  https://github.com/jmorrell/backbone.obscura/pull/27
 */

(function (root, factory) {
  if (typeof exports === "object") {
    module.exports = factory(require("underscore"), require("backbone"));
  } else {
    // @ts-ignore
    if (typeof define === "function" && define.amd) {
      // @ts-ignore
      define(["underscore", "backbone"], factory);
    } else {
      // @ts-ignore
      root.Backbone.Obscura = factory(root["_"], root["Backbone"]);
    }
  }
})(typeof window !== "undefined" ? window : this, function (_: any, Backbone: any): any {
  function _requireDep(name: string): any {
    return { underscore: _, backbone: Backbone }[name];
  }

  let _bundleExports = (function (define?: any): any {
    function _require(index: any, name?: string): any {
      let module = _require.cache[index];
      if (!module) {
        let exports = {};
        module = _require.cache[index] = {
          id: index,
          exports: exports,
        };
        _require.modules[index].call(exports, module, exports);
      }
      return module.exports;
    }
    // @ts-ignore
    _require.cache = [];
    _require.modules = [
      function (module?: any, exports?: any): void {
        let _ = _requireDep("underscore");
        let Backbone = _requireDep("backbone");
        let FilteredCollection = _require(2);
        let SortedCollection = _require(5);
        let PaginatedCollection = _require(4);
        let proxyCollection = _require(1);
        let proxyEvents = _require(7);
        function Obscura(superset?: any, options?: any): void {
          // @ts-ignore
          this._superset = superset;
          // @ts-ignore
          this._filtered = new FilteredCollection(superset, options);
          // @ts-ignore
          this._sorted = new SortedCollection(this._filtered, options);
          // @ts-ignore
          this._paginated = new PaginatedCollection(this._sorted, options);
          // @ts-ignore
          proxyCollection(this._paginated, this);
          // @ts-ignore
          proxyEvents.call(this, this._filtered, filteredEvents);
          // @ts-ignore
          proxyEvents.call(this, this._sorted, sortedEvents);
          // @ts-ignore
          proxyEvents.call(this, this._paginated, paginatedEvents);
          // @ts-ignore
          this.initialize(options);
        }
        let methods: any = {
          // @ts-ignore
          superset: function () {
            // @ts-ignore
            return this._superset;
          },
          // @ts-ignore
          getFilteredLength: function () {
            // @ts-ignore
            return this._filtered.length;
          },
          removeTransforms: function () {
            // @ts-ignore
            this._filtered.resetFilters();
            // @ts-ignore
            this._sorted.removeSort();
            // @ts-ignore
            this._paginated.removePagination();
            return this;
          },
          destroy: function () {
            // @ts-ignore
            this.stopListening();
            // @ts-ignore
            this._filtered.destroy();
            // @ts-ignore
            this._sorted.destroy();
            // @ts-ignore
            this._paginated.destroy();
            // @ts-ignore
            this.length = 0;
            // @ts-ignore
            this.trigger("obscura:destroy");
          },
        };
        let filteredMethods = [
          "filterBy",
          "removeFilter",
          "resetFilters",
          "refilter",
          "hasFilter",
          "getFilters",
        ];
        let filteredEvents = ["filtered:add", "filtered:remove", "filtered:reset"];
        let sortedMethods = ["setSort", "reverseSort", "removeSort"];
        let sortedEvents = ["sorted:add", "sorted:remove"];
        let paginatedMethods = [
          "setPerPage",
          "setPage",
          "getPerPage",
          "getNumPages",
          "getPage",
          "hasNextPage",
          "hasPrevPage",
          "nextPage",
          "prevPage",
          "movePage",
          "removePagination",
          "firstPage",
          "lastPage",
        ];
        let paginatedEvents = [
          "paginated:change:perPage",
          "paginated:change:page",
          "paginated:change:numPages",
        ];
        let unsupportedMethods = [
          "add",
          "create",
          "remove",
          "set",
          "reset",
          "sort",
          "parse",
          "sync",
          "fetch",
          "push",
          "pop",
          "shift",
          "unshift",
        ];
        _.each(filteredMethods, function (method: string): void {
          methods[method] = function () {
            let result = FilteredCollection.prototype[method].apply(this._filtered, arguments);
            return result === this._filtered ? this : result;
          };
        });
        _.each(paginatedMethods, function (method: string): void {
          methods[method] = function () {
            let result = PaginatedCollection.prototype[method].apply(this._paginated, arguments);
            return result === this._paginated ? this : result;
          };
        });
        _.each(sortedMethods, function (method: string): void {
          methods[method] = function () {
            let result = SortedCollection.prototype[method].apply(this._sorted, arguments);
            return result === this._sorted ? this : result;
          };
        });
        _.each(unsupportedMethods, function (method: string): void {
          methods[method] = function () {
            throw new Error(
              "Backbone.Obscura: Unsupported method: " + method + "called on read-only proxy"
            );
          };
        });
        _.extend(Obscura.prototype, methods, Backbone.Events);
        // @ts-ignore
        Obscura = Backbone.Collection.extend(Obscura.prototype);
        Obscura.FilteredCollection = FilteredCollection;
        Obscura.SortedCollection = SortedCollection;
        Obscura.PaginatedCollection = PaginatedCollection;
        module.exports = Obscura;
      },
      function (module?: any, exports?: any): void {
        let _ = _requireDep("underscore");
        let Backbone = _requireDep("backbone");
        let blacklistedMethods = [
          "_onModelEvent",
          "_prepareModel",
          "_removeReference",
          "_reset",
          "add",
          "initialize",
          "sync",
          "remove",
          "reset",
          "set",
          "push",
          "pop",
          "unshift",
          "shift",
          "sort",
          "parse",
          "fetch",
          "create",
          "model",
          "off",
          "on",
          "listenTo",
          "listenToOnce",
          "bind",
          "trigger",
          "once",
          "stopListening",
        ];
        let eventWhiteList = [
          "add",
          "remove",
          "reset",
          "sort",
          "destroy",
          "sync",
          "request",
          "error",
        ];
        function proxyCollection(from: any, target: any): any {
          function updateLength() {
            target.length = from.length;
          }
          function pipeEvents(eventName: string): void {
            let args = _.toArray(arguments);
            let isChangeEvent = eventName === "change" || eventName.slice(0, 7) === "change:";
            if (eventName === "reset") {
              target.models = from.models;
            }
            if (_.contains(eventWhiteList, eventName)) {
              if (_.contains(["add", "remove", "destroy"], eventName)) {
                args[2] = target;
              } else if (_.contains(["reset", "sort"], eventName)) {
                args[1] = target;
              }
              // @ts-ignore
              target.trigger.apply(this, args);
            } else if (isChangeEvent) {
              if (target.contains(args[1])) {
                // @ts-ignore
                target.trigger.apply(this, args);
              }
            }
          }
          let methods: any = {};
          _.each(_.functions(Backbone.Collection.prototype), function (method: string): void {
            if (!_.contains(blacklistedMethods, method)) {
              methods[method] = function () {
                return from[method].apply(from, arguments);
              };
            }
          });
          _.extend(target, Backbone.Events, methods);
          target.listenTo(from, "all", updateLength);
          target.listenTo(from, "all", pipeEvents);
          target.models = from.models;
          updateLength();
          return target;
        }
        module.exports = proxyCollection;
      },
      function (module?: any, exports?: any): void {
        let _ = _requireDep("underscore");
        let Backbone = _requireDep("backbone");
        let proxyCollection = _require(1);
        let createFilter = _require(3);
        function invalidateCache(): void {
          // @ts-ignore
          this._filterResultCache = {};
        }
        function invalidateCacheForFilter(filterName: string): void {
          // @ts-ignore
          for (let cid in this._filterResultCache) {
            // @ts-ignore
            if (this._filterResultCache.hasOwnProperty(cid)) {
              // @ts-ignore
              delete this._filterResultCache[cid][filterName];
            }
          }
        }
        function addFilter(filterName: string, filterObj: any): void {
          // @ts-ignore
          if (this._filters[filterName]) {
            // @ts-ignore
            invalidateCacheForFilter.call(this, filterName);
          }
          // @ts-ignore
          this._filters[filterName] = filterObj;
          // @ts-ignore
          this.trigger("filtered:add", filterName);
        }
        function removeFilter(filterName: string) {
          // @ts-ignore
          delete this._filters[filterName];
          // @ts-ignore
          invalidateCacheForFilter.call(this, filterName);
          // @ts-ignore
          this.trigger("filtered:remove", filterName);
        }
        function execFilterOnModel(model: any): boolean {
          // @ts-ignore
          if (!this._filterResultCache[model.cid]) {
            // @ts-ignore
            this._filterResultCache[model.cid] = {};
          }
          // @ts-ignore
          let cache = this._filterResultCache[model.cid];
          // @ts-ignore
          for (let filterName in this._filters) {
            // @ts-ignore
            if (this._filters.hasOwnProperty(filterName)) {
              if (!cache.hasOwnProperty(filterName)) {
                // @ts-ignore
                cache[filterName] = this._filters[filterName].fn(model);
              }
              if (!cache[filterName]) {
                return false;
              }
            }
          }
          return true;
        }
        function execFilter(): void {
          let filtered = [];
          // @ts-ignore
          if (this._superset) {
            // @ts-ignore
            filtered = this._superset.filter(_.bind(execFilterOnModel, this));
          }
          // @ts-ignore
          if (filtered.length !== this._collection.length) {
            // @ts-ignore
            this._collection.reset(filtered);
          }
          // @ts-ignore
          this.length = this._collection.length;
        }
        function onReset(): void {
          // @ts-ignore
          execFilter.call(this, { reset: true });
        }
        function onSort() {
          // @ts-ignore
          let hasComparator = !!(this._superset && this._superset.comparator);
          // @ts-ignore
          execFilter.call(this, { reset: hasComparator });
        }
        function onAddChange(model: any): void {
          // @ts-ignore
          this._filterResultCache[model.cid] = {};
          // @ts-ignore
          if (execFilterOnModel.call(this, model)) {
            // @ts-ignore
            if (!this._collection.get(model.cid)) {
              // @ts-ignore
              let index = this.superset().indexOf(model);
              let filteredIndex = null;
              for (let i = index - 1; i >= 0; i -= 1) {
                // @ts-ignore
                if (this.contains(this.superset().at(i))) {
                  // @ts-ignore
                  filteredIndex = this.indexOf(this.superset().at(i)) + 1;
                  break;
                }
              }
              filteredIndex = filteredIndex || 0;
              // @ts-ignore
              this._collection.add(model, { at: filteredIndex });
            }
          } else {
            // @ts-ignore
            if (this._collection.get(model.cid)) {
              // @ts-ignore
              this._collection.remove(model);
            }
          }
          // @ts-ignore
          this.length = this._collection.length;
        }
        function onModelAttributeChange(model: any): void {
          if (typeof model === "undefined") {
            return;
          }
          // @ts-ignore
          this._filterResultCache[model.cid] = {};
          // @ts-ignore
          if (!execFilterOnModel.call(this, model)) {
            // @ts-ignore
            if (this._collection.get(model.cid)) {
              // @ts-ignore
              this._collection.remove(model);
            }
          }
        }
        function onAll(eventName: string, model?: any, value?: any): void {
          if (eventName.slice(0, 7) === "change:") {
            // @ts-ignore
            onModelAttributeChange.call(this, arguments[1]);
          }
        }
        function onModelRemove(model: any): void {
          // @ts-ignore
          if (this.contains(model)) {
            // @ts-ignore
            this._collection.remove(model);
          }
          // @ts-ignore
          this.length = this._collection.length;
        }
        function Filtered(superset: any): any {
          // @ts-ignore
          this._superset = superset;
          // @ts-ignore
          this._collection = new Backbone.Collection(superset.toArray());
          // @ts-ignore
          proxyCollection(this._collection, this);
          // @ts-ignore
          this.resetFilters();
          // @ts-ignore
          this.listenTo(this._superset, "reset", onReset);
          // @ts-ignore
          this.listenTo(this._superset, "sort", onSort);
          // @ts-ignore
          this.listenTo(this._superset, "add change", onAddChange);
          // @ts-ignore
          this.listenTo(this._superset, "remove", onModelRemove);
          // @ts-ignore
          this.listenTo(this._superset, "all", onAll);
        }
        let methods: any = {
          defaultFilterName: "__default",
          filterBy: function (filterName: string, filter?: any): void {
            if (!filter) {
              filter = filterName;
              filterName = this.defaultFilterName;
            }
            addFilter.call(this, filterName, createFilter(filter));
            execFilter.call(this);
            return this;
          },
          removeFilter: function (filterName?: string): void {
            let fi: string;
            if (!filterName) {
              fi = this.defaultFilterName;
            } else {
              fi = filterName;
            }
            removeFilter.call(this, fi);
            execFilter.call(this);
            return this;
          },
          resetFilters: function (): void {
            this._filters = {};
            invalidateCache.call(this);
            this.trigger("filtered:reset");
            if (this._superset.length !== this._collection.length) {
              execFilter.call(this);
            }
            return this;
          },
          superset: function (): void {
            return this._superset;
          },
          refilter: function (arg?: any): any {
            if (typeof arg === "object" && arg.cid) {
              onAddChange.call(this, arg);
            } else {
              invalidateCache.call(this);
              execFilter.call(this);
            }
            return this;
          },
          getFilters: function (): any {
            return _.keys(this._filters);
          },
          hasFilter: function (name: string): boolean {
            return _.contains(this.getFilters(), name);
          },
          destroy: function (): void {
            this.stopListening();
            this._collection.reset([]);
            this._superset = this._collection;
            this.length = 0;
            this.trigger("filtered:destroy");
          },
        };
        _.extend(Filtered.prototype, methods, Backbone.Events);
        module.exports = Filtered;
      },
      function (module?: any, exports?: any): void {
        let _ = _requireDep("underscore");
        function convertKeyValueToFunction(key: any, value: any) {
          return function (model: any): boolean {
            return model.get(key) === value;
          };
        }
        function convertKeyFunctionToFunction(key: any, fna: any) {
          return function (model: any): boolean {
            // @ts-ignore
            return fn(model.get(key));
          };
        }
        function createFilterObject(filterFunction: any, keys: any) {
          if (!_.isArray(keys)) {
            keys = null;
          }
          return {
            fn: filterFunction,
            keys: keys,
          };
        }
        function createFilterFromObject(filterObj: any) {
          let keys = _.keys(filterObj);
          let filterFunctions = _.map(keys, function (key: any) {
            let val = filterObj[key];
            if (_.isFunction(val)) {
              return convertKeyFunctionToFunction(key, val);
            }
            return convertKeyValueToFunction(key, val);
          });
          let filterFunction = function (model: any): boolean {
            for (let i = 0; i < filterFunctions.length; i++) {
              if (!filterFunctions[i](model)) {
                return false;
              }
            }
            return true;
          };
          return createFilterObject(filterFunction, keys);
        }
        function createFilter(filter: any, keys: any) {
          if (_.isFunction(filter)) {
            return createFilterObject(filter, keys);
          }
          if (_.isObject(filter)) {
            return createFilterFromObject(filter);
          }
        }
        module.exports = createFilter;
      },
      function (module?: any, exports?: any): void {
        let _ = _requireDep("underscore");
        let Backbone = _requireDep("backbone");
        let proxyCollection = _require(1);
        function getPageLimits() {
          // @ts-ignore
          let start = this.getPage() * this.getPerPage();
          // @ts-ignore
          let end = start + this.getPerPage();
          return [start, end];
        }
        function updatePagination(): void {
          // @ts-ignore
          let pages = getPageLimits.call(this);
          // @ts-ignore
          this._collection.reset(this.superset().slice(pages[0], pages[1]));
        }
        function updateNumPages() {
          // @ts-ignore
          let currentNumPages = this._totalPages;
          // @ts-ignore
          let length = this.superset().length;
          // @ts-ignore
          let perPage = this.getPerPage();
          let totalPages =
            length % perPage === 0 ? length / perPage : Math.floor(length / perPage) + 1;
          // @ts-ignore
          let numPagesChanged = this._totalPages !== totalPages;
          // @ts-ignore
          this._totalPages = totalPages;
          if (numPagesChanged) {
            // @ts-ignore
            this.trigger("paginated:change:numPages", {
              numPages: totalPages,
            });
          }
          // @ts-ignore
          if (this.getPage() >= totalPages) {
            // @ts-ignore
            this.setPage(totalPages - 1);
            return true;
          }
        }
        function recalculatePagination(): void {
          // @ts-ignore
          if (updateNumPages.call(this)) {
            return;
          }
          // @ts-ignore
          updatePagination.call(this);
        }
        function difference(arrayA: any, arrayB: any): any {
          let maxLength = _.max([arrayA.length, arrayB.length]);
          for (let i = 0, j = 0; i < maxLength; i += 1, j += 1) {
            if (arrayA[i] !== arrayB[j]) {
              if (arrayB[i - 1] === arrayA[i]) {
                j -= 1;
              } else if (arrayB[i + 1] === arrayA[i]) {
                j += 1;
              } else {
                return arrayA[i];
              }
            }
          }
        }
        function onAddRemove(model?: any, collection?: any, options?: any): void {
          // @ts-ignore
          if (updateNumPages.call(this)) {
            return;
          }
          // @ts-ignore
          let pages = getPageLimits.call(this);
          let start = pages[0],
            end = pages[1];
          // @ts-ignore
          let toAdd = difference(this.superset().slice(start, end), this._collection.toArray());
          // @ts-ignore
          let toRemove = difference(this._collection.toArray(), this.superset().slice(start, end));
          if (toRemove) {
            // @ts-ignore
            this._collection.remove(toRemove);
          }
          if (toAdd) {
            // @ts-ignore
            this._collection.add(toAdd, {
              at: this.superset().indexOf(toAdd) - start,
            });
          }
        }
        function Paginated(superset: any, options: any): void {
          // @ts-ignore
          this._superset = superset;
          // @ts-ignore
          this._collection = new Backbone.Collection(superset.toArray());
          // @ts-ignore
          this._page = 0;
          // @ts-ignore
          this.setPerPage(options && options.perPage ? options.perPage : null);
          // @ts-ignore
          proxyCollection(this._collection, this);
          // @ts-ignore
          this.listenTo(this._superset, "add remove", onAddRemove);
          // @ts-ignore
          this.listenTo(this._superset, "reset sort", recalculatePagination);
        }
        let methods = {
          removePagination: function () {
            this.setPerPage(null);
            return this;
          },
          setPerPage: function (perPage: any) {
            // @ts-ignore
            this._perPage = perPage;
            recalculatePagination.call(this);
            this.setPage(0);
            // @ts-ignore
            this.trigger("paginated:change:perPage", {
              perPage: perPage,
              numPages: this.getNumPages(),
            });
            return this;
          },
          setPage: function (page: any) {
            let lowerLimit = 0;
            let upperLimit = this.getNumPages() - 1;
            page = page > lowerLimit ? page : lowerLimit;
            page = page < upperLimit ? page : upperLimit;
            page = page < 0 ? 0 : page;
            // @ts-ignore
            this._page = page;
            updatePagination.call(this);
            // @ts-ignore
            this.trigger("paginated:change:page", { page: page });
            return this;
          },
          getPerPage: function (): number {
            // @ts-ignore
            return this._perPage || this.superset().length || 1;
          },
          getNumPages: function (): number {
            // @ts-ignore
            return this._totalPages;
          },
          getPage: function (): number {
            // @ts-ignore
            return this._page;
          },
          hasNextPage: function (): boolean {
            return this.getPage() < this.getNumPages() - 1;
          },
          hasPrevPage: function (): boolean {
            return this.getPage() > 0;
          },
          nextPage: function () {
            this.movePage(1);
            return this;
          },
          prevPage: function () {
            this.movePage(-1);
            return this;
          },
          firstPage: function () {
            this.setPage(0);
          },
          lastPage: function () {
            this.setPage(this.getNumPages() - 1);
          },
          movePage: function (delta: number) {
            this.setPage(this.getPage() + delta);
            return this;
          },
          superset: function (): any {
            // @ts-ignore
            return this._superset;
          },
          destroy: function (): void {
            // @ts-ignore
            this.stopListening();
            // @ts-ignore
            this._collection.reset([]);
            // @ts-ignore
            this._superset = this._collection;
            // @ts-ignore
            this._page = 0;
            // @ts-ignore
            this._totalPages = 0;
            // @ts-ignore
            this.length = 0;
            // @ts-ignore
            this.trigger("paginated:destroy");
          },
        };
        _.extend(Paginated.prototype, methods, Backbone.Events);
        module.exports = Paginated;
      },
      function (module?: any, exports?: any): void {
        let _ = _requireDep("underscore");
        let Backbone = _requireDep("backbone");
        let proxyCollection = _require(1);
        let reverseSortedIndex = _require(6);
        function lookupIterator(value: any): any {
          return _.isFunction(value)
            ? value
            : function (obj: any): any {
                return obj.get(value);
              };
        }
        function modelInsertIndex(model: any): any {
          // @ts-ignore
          if (!this._comparator) {
            // @ts-ignore
            return this._superset.indexOf(model);
          } else {
            // @ts-ignore
            if (!this._reverse) {
              // @ts-ignore
              return _.sortedIndex(
                this._collection.toArray(),
                model,
                lookupIterator(this._comparator)
              );
            } else {
              // @ts-ignore
              return reverseSortedIndex(
                this._collection.toArray(),
                model,
                lookupIterator(this._comparator)
              );
            }
          }
        }
        function onAdd(model: any): void {
          // @ts-ignore
          let index = modelInsertIndex.call(this, model);
          // @ts-ignore
          this._collection.add(model, { at: index });
        }
        function onRemove(model: any): void {
          // @ts-ignore
          if (this.contains(model)) {
            // @ts-ignore
            this._collection.remove(model);
          }
        }
        function onChange(model: any): void {
          // @ts-ignore
          if (
            this.contains(model) &&
            this._collection.indexOf(model) !== modelInsertIndex.call(this, model)
          ) {
            // @ts-ignore
            this._collection.remove(model);
            // @ts-ignore
            onAdd.call(this, model);
          }
        }
        function sort(): void {
          // @ts-ignore
          if (!this._comparator) {
            // @ts-ignore
            this._collection.reset(this._superset.toArray());
            return;
          }
          // @ts-ignore
          let newOrder = this._superset.sortBy(this._comparator);
          // @ts-ignore
          this._collection.reset(this._reverse ? newOrder.reverse() : newOrder);
        }
        function Sorted(superset: any): void {
          // @ts-ignore
          this._superset = superset;
          // @ts-ignore
          this._reverse = false;
          // @ts-ignore
          this._comparator = null;
          // @ts-ignore
          this._collection = new Backbone.Collection(superset.toArray());
          // @ts-ignore
          proxyCollection(this._collection, this);
          // @ts-ignore
          this.listenTo(this._superset, "add", onAdd);
          // @ts-ignore
          this.listenTo(this._superset, "remove", onRemove);
          // @ts-ignore
          this.listenTo(this._superset, "change", onChange);
          // @ts-ignore
          this.listenTo(this._superset, "reset", sort);
        }
        let methods = {
          setSort: function (comparator?: any, direction?: any): any {
            // @ts-ignore
            this._direction = direction;
            // @ts-ignore
            this._reverse = direction === "desc" ? true : false;
            // @ts-ignore
            this._comparator = comparator;
            sort.call(this);
            if (!comparator) {
              // @ts-ignore
              this.trigger("sorted:remove");
            } else {
              // @ts-ignore
              this.trigger("sorted:add");
            }
            return this;
          },
          reverseSort: function () {
            // @ts-ignore
            this._reverse = !this._reverse;
            sort.call(this);
            return this;
          },
          removeSort: function () {
            this.setSort();
            return this;
          },
          // @ts-ignore
          superset: function () {
            // @ts-ignore
            return this._superset;
          },
          destroy: function () {
            // @ts-ignore
            this.stopListening();
            // @ts-ignore
            this._collection.reset([]);
            // @ts-ignore
            this._superset = this._collection;
            // @ts-ignore
            this.length = 0;
            // @ts-ignore
            this.trigger("sorted:destroy");
          },
        };
        _.extend(Sorted.prototype, methods, Backbone.Events);
        module.exports = Sorted;
      },
      function (module?: any, exports?: any): void {
        let _ = _requireDep("underscore");
        function lookupIterator(value: any): any {
          return _.isFunction(value)
            ? value
            : function (obj: any): any {
                return obj[value];
              };
        }
        function reverseSortedIndex(array?: any, obj?: any, iterator?: any, context?: any): number {
          iterator = iterator == null ? _.identity : lookupIterator(iterator);
          let value = iterator.call(context, obj);
          let low = 0,
            high = array.length;
          while (low < high) {
            let mid = (low + high) >>> 1;
            iterator.call(context, array[mid]) < value ? (high = mid) : (low = mid + 1);
          }
          return low;
        }
        module.exports = reverseSortedIndex;
      },
      function (module?: any, exports?: any): void {
        let _ = _requireDep("underscore");
        function proxyEvents(from?: any, eventNames?: any[]): any {
          _.each(
            eventNames,
            function (eventName: any) {
              // @ts-ignore
              this.listenTo(from, eventName, function () {
                let args = _.toArray(arguments);
                args.unshift(eventName);
                // @ts-ignore
                this.trigger.apply(this, args);
              });
              // @ts-ignore
            },
            this
          );
        }
        module.exports = proxyEvents;
      },
    ];
    return _require(0);
  })();

  return _bundleExports;
});
